import { useLocation } from 'react-router-dom';

export const useWorkflowContext = () => {
  const location = useLocation();
  
  const isAdminContext = location.pathname.includes('/admin/');
  const isStandaloneTemplateEditor = location.pathname.startsWith('/template-editor');
  
  // Extract template type from current URL path
  const getTemplateTypeFromPath = (): string => {
    const match = location.pathname.match(/\/(evaluate|improve|develop)\//i);
    return match ? match[1].toLowerCase() : '';
  };
  
  const getWorkflowPath = (templateId: string, templateTitle: string, step: string, templateType?: string) => {
    const typeFromPath = getTemplateTypeFromPath();
    const type = templateType || typeFromPath; // Use provided type or extract from path
    const encodedTemplateTitle = encodeURIComponent(templateTitle ?? '');
    
    if (isAdminContext) {
      if (type) {
        return `/admin/create-a-template/${type}/${templateId}/${encodedTemplateTitle}/${step}`;
      }
      return `/admin/create-a-template/${templateId}/${encodedTemplateTitle}/${step}`;
    }
    
    if (isStandaloneTemplateEditor) {
      if (type) {
        return `/template-editor/${type}/${templateId}/${encodedTemplateTitle}/${step}`;
      }
      return `/template-editor/${templateId}/${encodedTemplateTitle}/${step}`;
    }
    
    if (type) {
      return `/portal/template-editor/${type}/${templateId}/${encodedTemplateTitle}/${step}`;
    }
    return `/portal/template-editor/${templateId}/${encodedTemplateTitle}/${step}`;
  };
  
  const getBackPath = () => {
    if (isAdminContext) {
      // If we're in the create template flow, go back to create template page
      if (location.pathname.includes('/create-a-template/')) {
        return '/admin/create-a-template';
      }
      return '/admin/mandate-templates';
    }
    return '/template-editor/active';
  };
  
  const getCreateTemplatePath = () => {
    if (isAdminContext) {
      return '/admin/create-a-template';
    }
    return '/template-editor/active';
  };

  const templateType = getTemplateTypeFromPath();
  
  return {
    isAdminContext,
    templateType,
    getWorkflowPath,
    getBackPath,
    getCreateTemplatePath
  };
};
